<template>
  <section id="introduction" class="intro">
    <div class="wrapper">
      <h1>REACH YOUR GOALS</h1>
      <ul>
        <li>
          <img src="./img/intro1.png" />
          <a href="#samples">Weight Loss</a>
        </li>
        <li>
          <img src="./img/intro2.png" />
          <a href="#samples">Gain Muscle</a>
        </li>
        <li>
          <img src="./img/intro3.png" />
          <a href="#samples">Improve Flexibility</a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {

}
</script>

<style>

</style>
